import styled, { css } from 'styled-components';

import Tooltip from '../../Tooltip';

type ContainerProps = {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #b0bec5;
  border-radius: 6px;
  padding: 10px 2px 10px 10px;
  width: 100%;
  color: #4b4d63;

  // abaixo do primeiro
  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      color: #c53030 !important;
      border-color: #c53030 !important;
    `}

  ${props =>
    props.isFocused ?
    css`
      color: var(--azul-razio);
      border-color: var(--azul-razio);
    ` : css`
      color: #4b4d63;
      border-color: #b3b5c6;
    `
	}  

  ${props =>
    props.isField &&
    css`
      // color: var(--azul-razio);
    `}

  input {
    flex: 1;
		width: 100%;
    background: transparent;
    border: 0;
    color: #333;
    font-weight: 500;

    :focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }

    &::placeholder {
      color: #90a4ae;
    }
  }

  > svg {
    font-size: 20px;
    margin-right: 10px;
		// margin-left: 10px;
  }

  @media (max-width: 400px) {
    /* input {
      font-size: 14px;
    } */

    svg {
      margin-right: 12px;
    }
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
